import { createFileRoute } from "@tanstack/react-router";
import { AcoesPreviewPage } from "@/paginas/pg_acoes/acoes-preview";

export const Route = createFileRoute("/_authenticated/acoes-preview")({
  component: AcoesPreviewPage,
});
